enum EMatchStatus {
    "status.toBePlayed",
    "status.ongoing",
    "status.waitingModeration",
    "status.completed"
}

export default EMatchStatus